import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("aethel_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("aethel_cart", JSON.stringify(items));
  }, [items]);

  const key = (p, variant) => `${p.id}::${variant || ""}`;

  const addItem = (product, qty = 1, variant = "") => {
    setItems((prev) => {
      const k = key(product, variant);
      const existing = prev.find((i) => key(i, i.variant) === k);
      if (existing) {
        return prev.map((i) =>
          key(i, i.variant) === k ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          qty,
          variant,
        },
      ];
    });
  };

  const updateQty = (product_id, variant, qty) => {
    if (qty < 1) return;
    setItems((prev) =>
      prev.map((i) =>
        i.product_id === product_id && (i.variant || "") === (variant || "")
          ? { ...i, qty }
          : i
      )
    );
  };

  const removeItem = (product_id, variant) => {
    setItems((prev) =>
      prev.filter(
        (i) =>
          !(i.product_id === product_id && (i.variant || "") === (variant || ""))
      )
    );
  };

  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clearCart, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
